import React, { useEffect, useRef, useState } from 'react'
import {
  Badge, Box, IconButton, List, ListItem, ListItemText, Menu, Tooltip, Typography,
} from '@material-ui/core'
import NotificationsIcon from '@material-ui/icons/Notifications'
import { useNavigate, useLocation } from 'react-router-dom'
import api from '../../api/client'
import { toFarsiDigits } from '../../assets/utils'

const TYPE_STYLE = {
  transfer: { icon: '💳', bg: '#fff3e0', fg: '#e65100' },
  message: { icon: '✉️', bg: '#e3f2fd', fg: '#1565c0' },
  expiry: { icon: '⏳', bg: '#ffebee', fg: '#c62828' },
}

/** زنگولهٔ اعلان‌ها — شمارش هر ۶۰ ثانیه + پنل اعلانها */
const NotificationBell = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname
  const [count, setCount] = useState(0)
  const [items, setItems] = useState([])
  const [open, setOpen] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const anchorRef = useRef(null)

  const refresh = () => {
    if (!localStorage.getItem('access')) return
    api.get('users/notifications/')
      .then((res) => {
        setCount(res.data.count || 0)
        setItems(res.data.items || [])
        setLoaded(true)
      })
      .catch(() => {})
  }

  useEffect(() => {
    refresh()
    const iv = setInterval(refresh, 60000)
    return () => clearInterval(iv)
  }, [pathname])

  const handleClick = (e) => {
    setLoaded(false)
    refresh()
    setOpen(Boolean(anchorRef.current) ? !open : true)
  }

  const close = () => setOpen(false)

  const openItem = (item) => {
    if (item.type === 'transfer') {
      api.post('users/notifications/').catch(() => {})
    }
    setOpen(false)
    refresh()
    navigate(item.link || '/')
  }

  return (
    <>
      <Tooltip title="اعلان‌ها">
        <IconButton color="inherit" onClick={handleClick} ref={anchorRef} style={{ marginRight: 2 }}>
          <Badge badgeContent={count > 0 ? toFarsiDigits(count) : null} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          style: { width: 320, maxWidth: '92vw', borderRadius: 12, marginTop: 6 },
        }}
      >
        <Box style={{ padding: '10px 14px 4px' }}>
          <Typography style={{ fontWeight: 800, fontSize: 13.5, color: '#1a237e' }}>
            🔔 اعلان‌ها
          </Typography>
        </Box>

        {loaded && items.length === 0 && (
          <ListItem>
            <ListItemText primaryTypographyProps={{ style: { fontSize: 12.5, color: '#8a92b2', textAlign: 'center' } }}>
              اعلان جدیدی ندارید
            </ListItemText>
          </ListItem>
        )}
        <List style={{ padding: '4px 0 8px' }}>
          {items.map((item) => {
            const st = TYPE_STYLE[item.type] || { icon: '🔔', bg: '#f4f6fb', fg: '#3949ab' }
            return (
              <ListItem
                key={item.id}
                button
                onClick={() => openItem(item)}
                style={{ alignItems: 'flex-start', padding: '8px 14px' }}
              >
                <Box style={{
                  width: 34, height: 34, borderRadius: 10, background: st.bg,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 16, marginLeft: 10, flexShrink: 0,
                }}>{st.icon}</Box>
                <ListItemText
                  primary={item.title}
                  secondary={item.body}
                  primaryTypographyProps={{ style: { fontWeight: 700, fontSize: 13, color: st.fg } }}
                  secondaryTypographyProps={{ style: { fontSize: 12, color: '#5c6370', lineHeight: 1.8 } }}
                />
              </ListItem>
            )
          })}
        </List>
      </Menu>
    </>
  )
}

export default NotificationBell
